import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import TermsAndConditionsPage from "./terms-and-conditions-page";

export default (
  <Route
    path="terms-and-conditions"
    element={
      <Protected
        path="/admin/terms-and-conditions"
        roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
      >
        <TermsAndConditionsPage />
      </Protected>
    }
  />
);
